var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficOtherNews = function SvgLiveTrafficOtherNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M12.009 22.08c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.009 16.937a4.857 4.857 0 1 0 0-9.715 4.857 4.857 0 0 0 0 9.715"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D77A2D",
    d: "M11.535 16.035v-4.82h.74v4.82zm.376-5.623a.527.527 0 0 1-.373-.147.474.474 0 0 1-.154-.355c0-.138.051-.256.154-.354a.527.527 0 0 1 .373-.148c.145 0 .268.05.37.148a.47.47 0 0 1 .157.354.47.47 0 0 1-.156.355.515.515 0 0 1-.37.147"
  })));
};
export default SvgLiveTrafficOtherNews;